export const PromotionTypePortuguese: Record<string, string> = {
  FixedValueDiscount: 'Desconto no ticket em valor',
  PercentageDiscount: 'Desconto no ticket em percentual',
  MinorValueItem: 'Peça menor valor',
  FixedPriceByPackage: 'Preço único por pacote',
  ItemsPercentageDiscount: 'Desconto peça/serviço porcentagem',
  ItemsFixedValueDiscount: 'Desconto peça/serviço valor',
};
